import { SET_PERKS } from "../actions/perks";

const INITIAL_STATE = {
  perks: {},
};

const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_PERKS:
      return {
        ...state,
        perks: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
